import { styled } from '@mui/material/styles';

import DefaultInput from 'src/components/DefaultInput';
import Input from 'src/components/Input';

export const Container = styled('div')({
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  overflow: 'hidden',
});

export const ContentsContainer = styled('div')({});

export const DYDXContainer = styled('div')(({ theme }) => ({
  padding: '2.4rem',

  marginTop: '3rem',

  borderRadius: '1rem',

  color: theme.colors.base01,
  backgroundColor: theme.colors.base06,
}));

export const DYDXIconContainer = styled('div')({
  width: '4.8rem',
  height: '4.8rem',

  '& > svg': {
    width: '4.8rem',
    height: '4.8rem',
  },
});

export const DYDXTopContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  marginBottom: '2rem',

  color: theme.colors.base01,
}));

export const DYDXTopLeftContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base02,
}));

export const DYDXTopLeftAmountContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base01,
}));

export const DYDXTopRightContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1rem',
});

export const AmountPresetButton = styled('button')(({ theme }) => ({
  width: '4.4rem',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  padding: '0.4rem 0',

  border: 'none',

  borderRadius: '0.8rem',

  color: theme.colors.base01,
  backgroundColor: theme.colors.base04,

  '&:hover': {
    backgroundColor: theme.colors.base05,
    cursor: 'pointer',
  },
}));

export const DYDXBodyContainer = styled('div')({
  height: '100%',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const DetailContainer = styled('div')({
  width: 'calc(100% - 8rem)',

  position: 'absolute',
  bottom: '13.4rem',
});

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  flexShrink: 0,
});

export const HeaderTitle = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

type WrapperContainerProps = {
  'data-is-open': boolean;
};

export const WrapperContainer = styled('div')<WrapperContainerProps>((props) => ({
  position: 'absolute',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',

  display: props['data-is-open'] ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '1',
  overflowY: 'auto',

  backgroundColor: 'rgba(0, 0, 0, 0.6)',

  borderRadius: '2rem',
}));

export const TokenButton = styled('button')({
  height: '100%',

  padding: '0',

  border: 'none',

  backgroundColor: 'transparent',

  display: 'flex',
  alignItems: 'center',

  columnGap: '1.2rem',

  '&:hover': {
    cursor: 'pointer',
  },
});

export const ImageContainer = styled('div')({
  '& > img': {
    width: '4.8rem',
    height: '4.8rem',
  },
});

export const TokenRightContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
});

export const StyledInput = styled(DefaultInput)({
  height: '3rem',
});

export const TokenTextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',

  rowGap: '0.5rem',
});

export const TokenTextTopContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',

  columnGap: '0.4rem',

  color: theme.colors.base01,

  '&:hover': {
    opacity: '0.8',
  },
}));

export const RightChevronIconContainer = styled('div')({
  width: '2rem',
  height: '2rem',

  '& > svg': {
    width: '2rem',
    height: '2rem',
  },
});

export const InputContainer = styled('div')(({ theme }) => ({
  padding: '2.4rem',

  borderRadius: '1rem',

  border: `0.1rem solid ${theme.colors.base04}`,

  color: theme.colors.base02,

  backgroundColor: theme.colors.base08,

  marginTop: '1.2rem',

  '&:hover': {
    border: `0.1rem solid ${theme.colors.base01}`,
  },

  '&:focused': {
    border: `0.1rem solid ${theme.colors.base01}`,
  },
}));

export const StyledTextarea = styled(Input)({
  marginTop: '0.8rem',

  height: '100%',
});
